import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export default function SharedWishlist() {
  const { ownerId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/shared-wishlist/${ownerId}`).then(({ data }) => setData(data)).catch(() => setData(false));
  }, [ownerId]);

  if (data === null) return <div className="min-h-screen grid place-items-center text-mute">Loading…</div>;
  if (!data) return <div className="min-h-screen grid place-items-center text-mute">This wishlist could not be found.</div>;

  return (
    <div className="pt-24 sm:pt-28 pb-24 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center max-w-xl mx-auto">
            <div className="w-14 h-14 rounded-full bg-clay/10 grid place-items-center mx-auto mb-5"><Heart className="w-6 h-6 text-clay fill-clay" /></div>
            <div className="overline text-clay mb-3">A gift hint</div>
            <h1 className="font-serif text-4xl sm:text-6xl tracking-tighter">{data.owner_name}'s wishlist</h1>
            <p className="text-mute mt-4">Handmade treasures {data.owner_name.split(" ")[0]} is hoping for. Pick one and make their day.</p>
          </div>
        </Reveal>

        <div className="mt-14">
          {data.products.length === 0 ? (
            <p className="text-mute py-16 text-center">This wishlist is empty right now. <Link to="/shop" className="text-clay link-underline">Browse gifts</Link></p>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
              {data.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
